import { createSlice } from '@reduxjs/toolkit';
import { fetchJuOrju } from '../action/juOrjuAction';
const initialState = {
    juOrJu: null,
    isLoaderJu: false
};
export const JuOrJuSlice = createSlice({
    initialState,
    name: 'juOrJu',
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchJuOrju.pending, (state) => {
            state.isLoaderJu = true;
        })
            .addCase(fetchJuOrju.fulfilled, (state, action) => {
            state.juOrJu = action.payload;
            state.isLoaderJu = false;
        })
            .addCase(fetchJuOrju.rejected, (state) => {
            state.isLoaderJu = false;
        });
    }
});
export default JuOrJuSlice.reducer;
